import { render, staticRenderFns } from "./switchWidth-editor.vue?vue&type=template&id=51bb00a4&scoped=true&"
import script from "./switchWidth-editor.vue?vue&type=script&lang=js&"
export * from "./switchWidth-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bb00a4",
  null
  
)

export default component.exports